<template>
  <div id="sf-express-page">
    <div class="bread">
      <router-link class="bread-item" to="/orders">订单管理</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/orders/detail/'+ oid">订单详情</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/orders/detail/'+ oid +'/' + pid + '/sfpickup'">顺丰上门取资料服务</router-link>
    </div>
    <sf-order-mail-list :order="order" :show-ensure="true" @ensureChanged="changeEnsure"></sf-order-mail-list>

    <div class="express-address">
      <div class="header">
        <div class="title">顺丰上门取资料服务</div>
        <div class="description">请务必在下单前备齐全部邮寄资料；顺丰会在取件前通过短信发送快递员联系方式，若快递员未及时上门，请根据短信提供的信息联系快递员。</div>
      </div>
      <div class="content">
        <div class="title-box">
          请选择或添加邮寄地址：

          <span class="new-receive-address" @click.stop="openAddrModal()"><img src="../assets/imgs/add.png" alt="">
            <span>新增寄件地址</span>
          </span>
        </div>
        <div class="address-box">
          <ul class="clearfix">
            <li class="address-item no-item" @click="openAddrModal()" v-if="addresses && !addresses.length">
              <div class="icon"></div>
              <div class="txt">添加收货地址</div>
            </li>
            <li class="address-item" v-for="(v, i) in addresses" :key="v.peer_address_id" :class="{ 'active': v.peer_address_id == sfAddress.peer_address_id, 'no-m-l': (i % 3 === 0) }" @click="sfAddressHandle(v)">
              <div class="person">
                {{v.addressee}}
                <span>{{v.mobile_phone}}</span>
              </div>
              <div class="addr">
                {{getAddress(pcds, v)}}
              </div>

              <div class="actions">
                <a @click.stop="editAddress(v)">编辑</a>
              </div>
            </li>
          </ul>

          <div class="more-address" v-if="originAddresses && originAddresses.length > 3">
            <span class="open-more-address" @click="showMoreAddresses(originAddresses)">
              <span>更多地址</span>
              <img :class="{'rotate': originAddresses.length === addresses.length}" src="../assets/imgs/more-arrow.png" alt="arrow"></span>
          </div>

          <div class="current-address" v-if="order.supplier_address">
            <div class="left-icon">
              <img src="../assets/imgs/location-gray.png" alt="address">
            </div>
            <div class="right-content">
              <div class="title">资料将被寄送至以下地址：</div>
              <div class="address">
                {{order.supplier_address.addressee}}（{{ order.country + '，' + User.peer.visa_peer_id }}） {{order.supplier_address.mobile_phone}} {{getAddress(pcds, order.supplier_address)}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer" v-if="pickUpAmountObj.original_price">
        <div class="total-free">
          费用：
          <span class="current-free">￥{{pickUpAmountObj.pickup_amount/100}}</span>
          <span v-if="pickUpAmountObj.pickup_amount === 0" class="origin-free">￥{{pickUpAmountObj.original_price/100}}</span>
        </div>
        <div class="free-tips" v-if="pickUpAmountObj.pickup_amount === 0">本订单支持免费邮寄一次，费用由上上签承担</div>
        <!-- <p class="free-tips" v-else>本单已减免￥{{ ( pickUpAmountObj.original_price - pickUpAmountObj.pickup_amount ) / 100}}服务费</p> -->
      </div>
    </div>

    <div class="balance" v-if="!User.is_palmyou">
      <div class="header">余额信息</div>
      <div class="content">
        <div class="current-balance">
          <div class="left-icon"><img src="../assets/imgs/price.png" alt="price"></div>
          <div class="right-content">
            <div class="title">可用余额</div>
            <div class="balance-num">￥{{peer.balance_amount/100}}</div>
          </div>
        </div>

        <!-- <div class="balance-tips" v-if="peer.balance_amount < pickUpAmountObj.pickup_amount">余额不足，请先充值</div>

        <el-button type="primary" v-if="peer.balance_amount < pickUpAmountObj.pickup_amount" class="common-button" @click="recharge()">立即充值</el-button> -->
      </div>
    </div>

    <div class="pay">
      <div class="header" v-show="pickUpAmountObj.pickup_amount">
        <div class="service-name">顺丰上门取资料服务</div>
        <div class="price">￥
          <span v-text="pickUpAmountObj.pickup_amount / 100"></span>
        </div>
      </div>
      <div class="content">
        <el-button type="primary" @click="commit()" class="common-button">立即支付</el-button>
      </div>
    </div>

    <el-dialog :title="addrModalTitle" v-model="addrDialog" custom-class="ben-dialog addr-dialog" @close="addrModalClose">
      <el-form :model="addrModel" ref="dataForm" :rules="rules" label-width="80px">
        <el-form-item label="姓名" prop="addressee">
          <el-input type="text" v-model.trim="addrModel.addressee" :maxlength="15"></el-input>
        </el-form-item>

        <el-form-item label="电话" prop="mobile_phone">
          <el-input type="text" v-model.trim="addrModel.mobile_phone" placeholder="请填写手机号" :maxlength="11"></el-input>
        </el-form-item>

        <el-form-item label="地址" class="is-required pcds">
          <el-select v-model="addrModel.province_code" placeholder="省" @change="addrModel.city_code=''">
            <el-option :label="v" :value="parseInt(k)" v-for="(v,k) in pcds[86]" :key="k"></el-option>
          </el-select>

          <el-select v-model="addrModel.city_code" placeholder="市" @change="addrModel.county_code=''">
            <el-option :label="v" :value="parseInt(k)" v-for="(v,k) in pcds[addrModel.province_code]" :key="k"></el-option>
          </el-select>

          <el-select v-model="addrModel.county_code" placeholder="区">
            <el-option :label="v" :value="parseInt(k)" v-for="(v,k) in pcds[addrModel.city_code]" :key="k"></el-option>
          </el-select>

          <transition name="scaleY">
            <div class="el-form-item__error" v-if="!pcdValid && submitted">请选择省市区</div>
          </transition>
        </el-form-item>

        <el-form-item prop="detail_address">
          <el-input type="text" v-model.trim="addrModel.detail_address" placeholder="详细地址" :maxlength="50"></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input type="text" v-model.trim="addrModel.email" placeholder="用于接收通知书" :maxlength="50"></el-input>
        </el-form-item>

        <el-form-item style="margin-top:35px">
          <el-button type="primary" @click="addrFormSubmit" class="common-button">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="'订单支付'" v-model="payDialog" custom-class="pay-dialog" :show-close="false">
      <span class="cue">该订单将使用余额支付, 是否确认支付?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payDialog = false">再想想</el-button>
        <el-button type="primary" @click="orderSubmit">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 余额不足 -->
    <insufficient-balance-modal
      v-model="rechargeDialog"
      :order-id="oid"
      :from="'sfpickup'"
      :chargePrice="pickUpAmountObj.pickup_amount - peer.balance_amount"
      :fromParam="{ oid: oid, pid: pid }">
    </insufficient-balance-modal>
  </div>
</template>

<script>
import User from '@/libs/user';
import utils from '../libs/utils';
import Http from '../libs/http';
import addressUtils from '../libs/address-utils';
import validates from '../libs/validates';
import SFService from '../services/sf-service';
import sfOrderMailList from '../components/order-detail/sf-order-mail-list';
import pcdService from '../services/pcd-service';
import insufficientBalanceModal from './ordering/modals/insufficient-balance-modal';

export default {
  name: 'SfPickUp',
  data() {
    return {
      oid: +this.$route.params.oid,
      pid: +this.$route.params.pid,
      addresses: [], // 所有地址
      originAddresses: [], // 所有地址
      sfAddress: {}, // 选择的顺丰地址
      addrDialog: false, // 地址对话框是否打开
      peer: {}, // 同业
      product: {}, // 商品
      order: {}, // 订单
      addrModel: {
        // 地址对话框数据
        addressee: '',
        mobile_phone: '',
        email: '',
        province_code: '',
        city_code: '',
        county_code: '',
        detail_address: '',
        is_default: 0,
      },
      User,
      pickUpAmountObj: { pickup_amount: 0 },
      pcds: {},
      addrModalTitle: '', // 地址对话框标题
      addrForceDefault: false,
      addrToEdit: null,
      submitted: false,
      payDialog: false,
      materialEnsure: false,
      paying: false,
      rules: {
        addressee: [validates.required('姓名')],
        mobile_phone: [validates.required('电话'), validates.mobile('电话')],
        email: [validates.required('邮箱'), validates.email('邮箱')],

        detail_address: [validates.required('详细地址')],
      },
      rechargeDialog: false, // 账户余额不足模态框
    };
  },
  components: {
    sfOrderMailList,
    insufficientBalanceModal,
  },
  methods: {
    getAddress: addressUtils.getAddress,
    getAddresses() {
      Http.post('/peer_address_total_query', {}).then((data) => {
        this.originAddresses = data.result;
        // this.initDefaultAddress();
        this.showMoreAddresses(this.originAddresses, true);
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    /**
     * 设置默认的选中
     */
    initDefaultAddress() {
      // 这里就直接判断两个值了，如果要做就是用promise
      if (this.originAddresses.length > 0 && this.order.user_order_id) {
        if (this.order.order_pickup && this.order.order_pickup.length > 0) {
          const lastPickUpRecord = this.order.order_pickup[0];

          // 有tracking_number但是又到了这个页面代表选了但是没有付款，需要选中默认值
          if (!lastPickUpRecord.tracking_number) {
            this.sfAddress = SFService.getSfAddress(
              this.order,
              this.originAddresses,
            );
            this.pickUpAmountObj.pickup_amount = lastPickUpRecord.pickup_amount;
            this.pickUpAmountObj.original_price =
              lastPickUpRecord.original_price;
          }
        }
      }
    },
    openAddrModal() {
      this.sfAddressDefaultRemove = false;
      this.addrDialog = true;
      this.addrModalTitle = '添加地址';
      this.addrModel = {
        addressee: '',
        mobile_phone: '',
        email: '',
        province_code: '',
        city_code: '',
        county_code: '',
        detail_address: '',
        is_default: 0,
      };

      if (!this.addresses.length) {
        this.addrModel.is_default = 1;
        this.addrForceDefault = true;
      }
    },
    changeEnsure(checked) {
      this.materialEnsure = checked;
    },
    addrModalClose() {
      this.$refs.dataForm.resetFields();

      setTimeout(() => {
        this.addrForceDefault = false;
      }, 200);
    },
    addrFormSubmit() {
      this.submitted = true;

      this.$refs.dataForm.validate((valid) => {
        if (valid && this.pcdValid) {
          const { peer_address_id } = this.sfAddress;
          const action = this.addrModel.peer_address_id ? 'edit' : 'add';
          const url =
            action === 'add' ? '/peer_address_add' : '/peer_address_update';
          const toast = action === 'add' ? '添加成功' : '修改成功';

          const postData = utils.extend(true, {}, this.addrModel);

          postData.province_code = +postData.province_code;
          postData.city_code = +postData.city_code;
          postData.county_code = Number(postData.county_code) || 0;

          Http.post(url, postData).then((data) => {
            utils.msg.success(toast);
            this.addrDialog = false;

            if (action === 'add') {
              postData.peer_address_id = data.peer_address_id;
              this.originAddresses.splice(0, 0, postData);
              this.showMoreAddresses(this.originAddresses, true);
            } else {
              utils.extend(this.addrToEdit, postData);
              // 如果是编辑当前选择的地址，需要刷新供应商地址
              if (
                peer_address_id &&
                peer_address_id === postData.peer_address_id
              ) {
                this.recalculateSfPriceForChoosing(postData);
              }
            }
            this.addrToEdit = null;
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      });
    },
    editAddress(address) {
      this.addrModel = utils.extend({}, address);
      this.addrDialog = true;
      this.addrModalTitle = '编辑地址';
      this.addrToEdit = address;

      this.$nextTick()
        .then((vm) => {
          vm.addrModel.city_code = address.city_code;

          return vm.$nextTick();
        })
        .then((vm) => {
          vm.addrModel.county_code =
            address.county_code > 0 ? address.county_code : '';
        })
        .catch((e) => {
          if (e) console.log(e);
        });

      if (address.is_default) {
        this.addrForceDefault = true;
      }
    },
    // 顺丰上门地址选择处理
    sfAddressHandle(address, forceUpdatePrice) {
      if (address.peer_address_id === this.sfAddress.peer_address_id && !forceUpdatePrice) return;
      const url = '/pickup_submit';
      const postData = {
        user_order_id: this.oid,
        address: {
          addressee: address.addressee,
          mobile_phone: address.mobile_phone,
          province_code: address.province_code,
          city_code: address.city_code,
          county_code: address.county_code,
          detail_address: address.detail_address,
        },
      };

      if (forceUpdatePrice) {
        Http.post(url, postData).then((data) => {
          this.pickUpAmountObj = data;
          this.sfAddress = address;
        }).catch((e) => {
          if (e) console.log(e);
        });
      } else {
        utils.msgbox
          .confirm('是否确定使用该寄件地址？', '提示', {
            confirmButtonText: '　是　',
            cancelButtonText: ' 再想想 ',
            type: 'info',
          })
          .then(() => {
            Http.post(url, postData).then((data) => {
              this.pickUpAmountObj = data;
              this.sfAddress = address;
            }).catch((e) => {
              if (e) console.log(e);
            });
          })
          .catch((e) => {
            if (e) console.log(e);
          });
      }
    },
    getPeer() {
      Http.post('/visa_peer_query').then((data) => {
        this.peer = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    getOrder() {
      Http.post('/order_query', { user_order_id: this.oid }).then((data) => {
        this.order = data;
        // this.initDefaultAddress();
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 支付校验
    commit() {
      if (!this.materialEnsure) {
        return utils.msg.warning('请确认以上资料齐全');
      }

      if (!this.sfAddress.peer_address_id) {
        return utils.msg.warning('请选择寄件地址');
      }

      // 如果是金棕榈订单，则直接跳转到支付页面
      if (User.is_palmyou) {
        this.$router.replace({
          name: 'payConfirm',
          params: {
            oid: this.oid,
          },
          query: {
            typeid: 3,
            payPrice: this.pickUpAmountObj.pickup_amount / 100,
          },
        });
        return;
      }

      if (this.peer.balance_amount >= this.pickUpAmountObj.pickup_amount) {

        this.payDialog = true;
      } else {
        this.rechargeDialog = true;
      }
    },
    // 发起支付请求
    orderSubmit() {
      if (this.paying) return;
      this.paying = true;
      Http.post('/pickup_pay', {
        user_order_id: this.oid,
      }).then(() => {
        const message = '支付成功！';
        utils.msg.success(message);
        this.$router.push({ name: 'orderDetail', params: { oid: this.oid } });
      }).catch((e) => {
        this.paying = false;
        if (e) console.log(e);
        if (e.ret === -2) {
          this.payDialog = false;
          this.sfAddressHandle(this.sfAddress, true);
        }
      });
    },
    showMoreAddresses(originAddresses, onlyFistCol) {
      if (onlyFistCol) {
        this.addresses =
          originAddresses.length > 3
            ? originAddresses.slice(0, 3)
            : originAddresses;
      } else if (this.addresses.length === originAddresses.length) {
        this.addresses =
          originAddresses.length > 3
            ? originAddresses.slice(0, 3)
            : originAddresses;
      } else {
        this.addresses = originAddresses;
      }
    },
    updateMoreAddresses(originAddresses) {
      if (this.addresses.length === originAddresses.length) {
        this.addresses =
          originAddresses.length > 3
            ? originAddresses.slice(0, 3)
            : originAddresses;
      } else {
        this.addresses = originAddresses;
      }
    },
    recharge() {
      this.$router.push({ name: 'balance', query: { from: 'sfpickup', fromParam: utils.formatParam({ oid: this.oid, pid: this.pid }) } });
    },
    // 进入页面，刷新供应商地址，重新计算顺丰价格
    recalculateSfPrice() {
      const { need_pickup, order_pickup, user_order_id } = this.order;
      const _this = this;
      if (need_pickup === 0 || !order_pickup || order_pickup.length === 0) {
        return;
      }
      if (order_pickup[0] && order_pickup[0].tracking_number) {
        return;
      }
      const addressObj = order_pickup && order_pickup[0].address;
      const postData = {
        user_order_id,
        address: addressObj,
      };
      Http.post('/pickup_submit', postData).then((data) => {
        _this.pickUpAmountObj = data;
        _this.order.supplier_address = data.supplier_address;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    recalculateSfPriceForChoosing(address) {
      const { user_order_id } = this.order;
      const _this = this;
      const postData = {
        user_order_id,
        address: {
          addressee: address.addressee,
          mobile_phone: address.mobile_phone,
          province_code: address.province_code,
          city_code: address.city_code,
          county_code: address.county_code,
          detail_address: address.detail_address,
        },
      };
      Http.post('/pickup_submit', postData).then((data) => {
        _this.pickUpAmountObj = data;
      }).catch(() => {

        // 如果报错,则取消选中, 比如该地区不支持上门取件
        _this.sfAddress = {};
        _this.pickUpAmountObj = {};
      });
    },
  },
  mounted() {
    this.getAddresses();
    this.getPeer();
    this.getOrder();
  },
  computed: {
    pcdValid() {
      if (this.addrModel.city_code && this.pcds[this.addrModel.city_code]) {
        return this.addrModel.province_code && this.addrModel.city_code && this.addrModel.county_code;
      }
      return this.addrModel.province_code && this.addrModel.city_code;
    },
  },
  created() {
    pcdService.getPcd().then(pcds => (this.pcds = pcds)).catch((e) => {
      if (e) console.log(e);
    });
  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/variable";

#sf-express-page {
  width: 920px;
  margin: auto;
  padding-bottom: 100px;
  .cue{
    margin-left: 20px;
  }
  .express-address {
    margin-top: 15px;
    .header {
      padding: 14px 20px;
      background-color: #eaf3ff;
      .title {
        font-size: 16px;
        font-weight: 500;
        line-height: 16px;
        margin-bottom: 10px;
      }
      .description {
        font-size: 12px;
        color: #777;
        line-height: 12px;
      }
    }
    .content {
      padding: 20px 30px 20px 40px;
      background-color: #fff;
      .title-box {
        color: #333;
        font-size: 14px;
        .new-receive-address {
          float: right;
          cursor: pointer;
          img {
            display: inline-block;
            vertical-align: middle;
          }
          span {
            display: inline-block;
            vertical-align: middle;
            color: #5e9be1;
            font-size: 14px;
            line-height: 17px;
            margin-left: 4px;
          }
        }
      }
      .address-box {
        ul {
          padding: 0 0 20px 0;
          list-style: none;
          width: 100%;
          .address-item {
            width: 270px;
            height: 96px;
            border: 1px solid #f0f0f0;
            background: url(../assets/imgs/color-no-dai.png) no-repeat;
            background-size: 100% auto;
            padding: 16px 14px 14px 14px;
            margin-left: 20px;
            margin-top: 20px;
            float: left;
            cursor: pointer;
            position: relative;

            &.no-m-l {
              margin-left: 0;
            }

            &.active {
              background-image: url(../assets/imgs/color-dai.png);
              border: 1px solid #bed6f3;
            }

            &.no-item {
              margin: 20px auto 0 auto;
              background-image: url(../assets/imgs/color-dai-only.png);
              text-align: center;
              float: none;

              &::before {
                content: "";
                height: 100%;
                display: inline-block;
                vertical-align: middle;
              }

              .txt {
                display: inline-block;
                vertical-align: middle;
                font-size: 15px;
                color: #666;
              }

              .icon {
                display: inline-block;
                vertical-align: middle;
                position: relative;
                width: 15px;
                height: 15px;
                margin-right: 5px;

                &::before {
                  content: "";
                  display: block;
                  position: absolute;
                  top: 0;
                  left: 7px;
                  width: 1px;
                  height: 100%;
                  background-color: #666;
                }

                &::after {
                  content: "";
                  display: block;
                  position: absolute;
                  top: 7px;
                  left: 0;
                  width: 100%;
                  height: 1px;
                  background-color: #666;
                }
              }
            }

            .person {
              font-size: 14px;
              color: #333;
              margin-bottom: 5px;

              span {
                margin-left: 15px;
                font-size: 12px;
                color: #777;
              }
            }

            .addr {
              font-size: 12px;
              line-height: 22px;
              color: #777;
              max-height: 50px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .email {
              .addr;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-top: 2px;
            }

            .addr-default {
              position: absolute;
              top: 21px;
              right: 12px;
              width: 65px;
              text-align: center;
              height: 20px;
              line-height: 20px;
              border-radius: 3px;
              background-color: #b3b3b3;
              color: white;
              transform: scale(0.9);
              font-size: 12px;
            }

            .actions {
              position: absolute;
              bottom: 3px;
              right: 14px;
              font-size: 12px;
              display: none;

              a {
                color: @main;
                margin-left: 5px;
              }
            }

            &:hover {
              border-color: #bed6f3;

              .actions {
                display: block;
              }
            }
          }
        }
      }
      .more-address {
        margin-bottom: 20px;
        cursor: pointer;
        .open-more-address {
          line-height: 12px;
          span {
            color: #5e9be1;
            font-size: 12px;
            display: inline-block;
            vertical-align: middle;
          }
          img {
            transition: all 0.5s;
            display: inline-block;
            vertical-align: middle;
            &.rotate {
              transform: rotate(180deg);
            }
          }
        }
      }
      .current-address {
        display: flex;
        border-radius: 4px;
        background-color: #fbfbfb;
        .left-icon {
          width: 70px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .right-content {
          flex: 1;
          padding: 14px 0;
          .title {
            font-size: 14px;
            color: #333;
            line-height: 14px;
            margin-bottom: 10px;
          }
          .address {
            font-size: 14px;
            color: #777;
            line-height: 14px;
          }
        }
      }
    }
    .footer {
      border-top: 1px solid #f0f0f0;
      padding: 20px 30px;
      background-color: #fff;
      .total-free {
        text-align: right;
        font-size: 16px;
        color: #333;
        .current-free {
          color: #fc7906;
        }
        .origin-free {
          color: #aaaaaa;
          font-size: 12px;
          text-decoration: line-through;
        }
      }
      .free-tips {
        text-align: right;
        margin-top: 13px;
        font-size: 14px;
        color: #777;
      }
    }
  }
  .balance {
    padding: 20px 20px 15px 20px;
    background-color: #fff;
    margin-top: 15px;
    .header {
      color: #333;
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
    }
    .content {
      padding: 20px;
      display: flex;
      align-items: center;
      .current-balance {
        border-radius: 4px;
        border: 1px solid #5e9be1;
        display: flex;
        width: 160px;
        height: 70px;
        .left-icon {
          width: 65px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .right-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title {
            color: #333;
            font-size: 14px;
            line-height: 14px;
          }
          .balance-num {
            margin-top: 10px;
            color: #fc7906;
            font-size: 16px;
          }
        }
      }
      .balance-tips {
        margin-left: 60px;
        margin-right: 20px;
        color: #ff5a60;
        font-size: 14px;
      }
    }
  }
  .pay {
    margin-top: 15px;
    padding: 20px 30px;
    background-color: #fbfbfb;
    border-radius: 1px;
    border: 1px solid #f0f0f0;
    .header {
      text-align: right;
      font-size: 0;
      margin-bottom: 20px;
      .service-name {
        font-size: 14px;
        color: #777;
        line-height: 14px;
        margin-right: 35px;
        display: inline-block;
        vertical-align: baseline;
      }
      .price {
        display: inline-block;
        vertical-align: baseline;
        color: #fc7906;
        font-size: 16px;
        line-height: 16px;
        font-weight: 500;
        span {
          font-size: 24px;
          line-height: 24px;
        }
      }
    }
    .content {
      text-align: right;
      button {
        width: 300px;
        height: 44px;
        font-size: 16px;
        line-height: 44px;
      }
    }
  }
}
</style>

<style lang="less">
  #sf-express-page{
    .addr-dialog, .pay-dialog{
      width: 570px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ShunFengPickUp.vue